/**
 * @file XCOMM Album related fragments.
 */

import gql from 'graphql-tag';

export const AlbumMatchingDetails = gql`
  fragment AlbumMatchingDetails on Album {
    id
    name
    time_based_matching_enabled
    commander_enabled_match
    commander_enabled_flush
    root_album_folder {
      id
      tags {
        records {
          ... on IRecord {
            id
          }
        }
      }
    }
  }
`;
